import { recordingStatuses } from "../constants";

export const selectRecordingsForProject = (recordings, project) => {
  const selected = [];
  project.recordings.forEach((id) => selected.push(recordings.hash[id]));
  return selected;
};

export const applyFilters = (recordings, filters) => {
  const userFiltered = applyUserFilter(recordings, filters.user);
  return applyReviewerFilter(userFiltered, filters.reviewer);
};

const applyUserFilter = (recordings, filter) => {
  if (filter === recordingStatuses.ALL) return recordings;
  return recordings.filter((rec) => rec.user_status === filter);
};

const applyReviewerFilter = (recordings, filter) => {
  if (filter === recordingStatuses.ALL) return recordings;
  return recordings.filter((rec) => rec.reviewer_status === filter);
};

export const selectOneRecordingForProject = (recordings, project, number) => {
  if (!project) return;
  const rec = selectRecordingByNumber(recordings, project, number);
  if (!rec) return;

  rec.nextNum = number + 1 > project.recordings.length ? null : number + 1;
  rec.prevNum = number - 1 === 0 ? null : number - 1;

  rec.jumpNum = selectJumpToNumber(recordings, project, number);
  rec.reviewNum = selectReviewNumber(recordings, project, number);

  return rec;
};

const selectRecordingByNumber = (recordings, project, number) => {
  if (!number) return;
  const recId = project.recordings.find(
    (id) => recordings.hash[id].number === number
  );
  return { ...recordings.hash[recId] };
};

export const selectRecordingToPrefetchByNumber = (state, projectId, number) => {
  const proj = state.projects.hash[projectId];
  const recId = proj.recordings.find(
    (id) => state.recordings.hash[id].number === number
  );
  return { ...state.recordings.hash[recId] };
};

const selectJumpToNumber = (recordings, project, number) => {
  const jumpId = project.recordings.find((id) => {
    const rec = recordings.hash[id];
    return (
      rec.number > number && rec.user_status === recordingStatuses.NO_RECORDING
    );
  });
  if (!jumpId) return;
  return recordings.hash[jumpId].number;
};

const selectReviewNumber = (recordings, project, number) => {
  const reviewId = project.recordings.find((id) => {
    const rec = recordings.hash[id];
    return (
      rec.number > number &&
      rec.user_status !== recordingStatuses.NO_RECORDING &&
      rec.reviewer_status === recordingStatuses.UNREVIEWED
    );
  });
  if (!reviewId) return;
  return recordings.hash[reviewId].number;
};
